module.exports = __webpack_public_path__ + "static/media/plug-in.ad42cb6f.svg";